import type { Router } from "@/typeDefinitions/custom/Router";
import { SQDCEventActionTypeInternalType } from "@/graphql";

const IHEquipments = () => import("./views/Equipments/IHEquipments.vue");
const CreateIHEquipment = () => import("./views/Equipments/CreateIHEquipment.vue");
const UpdateIHEquipment = () => import("./views/Equipments/UpdateIHEquipment.vue");

const IHMaintenanceSchedule = () => import("./views/IHMaintenanceSchedule.vue");
const IHWeakPointAnalysis = () => import("./views/IHWeakPointAnalysis.vue");
const IHConfigs = () => import("./views/IHConfigs.vue");
const CreateIHConfig = () => import("./views/CreateIHConfig.vue");
const UpdateIHConfig = () => import("./views/UpdateIHConfig.vue");

const router: Router.LicensedRouterExportType = [
  {
    path: "/ih/equipments",
    name: "IHEquipments",
    component: IHEquipments,
    meta: {
      rights: ["ih.readWrite"],
    },
  },
  {
    path: "/ih/equipment",
    name: "CreateIHEquipment",
    component: CreateIHEquipment,
    meta: {
      rights: ["ih.readWrite"],
    },
  },
  {
    path: "/ih/equipment/:id",
    name: "UpdateIHEquipment",
    component: UpdateIHEquipment,
    meta: {
      rights: ["ih.readWrite"],
    },
    props: (route) => ({
      id: Number(route.params.id),
    }),
  },
  {
    path: "/ih/maintenanceSchedule",
    name: "IHMaintenanceSchedule",
    component: IHMaintenanceSchedule,
    meta: {
      rights: ["ih.readWrite"],
    },
  },
  {
    path: "/ih/weakPointAnalysis",
    name: "IHWeakPointAnalysis",
    component: IHWeakPointAnalysis,
    meta: {
      rights: ["ih.readWrite"],
    },
  },
  {
    path: "/ih/IHConfigs",
    name: "IHConfigs",
    component: IHConfigs,
    meta: {
      rights: ["ih.readWrite"],
    },
  },
  {
    path: "/ih/configOverview",
    name: "IHConfigOverview",
    component: () =>
      import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeConfigOverview.vue"),
    meta: {
      rights: ["ih.readWrite"],
    },
    props: {
      internalTypes: [
        SQDCEventActionTypeInternalType.IHFailureNotice,
        SQDCEventActionTypeInternalType.IHMaintenance,
        SQDCEventActionTypeInternalType.IHOrder,
      ],
      titleKey: "router.IHConfigOverview",
      detailRouteName: "IHConfigSettings",
    },
  },
  {
    path: "/ih/configOverview/:siteId",
    name: "IHConfigSettings",
    component: () =>
      import("@/modules/sqdc/components/eventActionConfig/SQDCEventActionTypeConfigSettings.vue"),
    meta: {
      rights: ["ih.readWrite"],
    },
    props: (route) => ({
      internalTypes: [
        SQDCEventActionTypeInternalType.IHFailureNotice,
        SQDCEventActionTypeInternalType.IHMaintenance,
        SQDCEventActionTypeInternalType.IHOrder,
      ],
      actionInternalTypes: [SQDCEventActionTypeInternalType.IHOrder],
      siteId: Number(route.params.siteId),
      titleKey: "router.IHConfigSettings",
    }),
  },
  {
    path: "/ih/ihConfig/new/:siteId",
    name: "CreateIHConfig",
    component: CreateIHConfig,
    meta: {
      rights: ["ih.readWrite"],
    },
    props: (route) => {
      return {
        siteId: Number(route.params.siteId),
      };
    },
  },
  {
    path: "/ih/ihConfig/:id",
    name: "UpdateIHConfig",
    component: UpdateIHConfig,
    props: (route) => ({
      id: route.params?.id ? Number(route.params.id) : undefined,
    }),
    meta: {
      rights: ["ih.readWrite"],
    },
  },
];

export default router;
